export default function displaySearch() {
  const form = document.querySelector(".form-search");
  const input = document.querySelector(".input-search");
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const value = input.value;
  });
}
